
import { createStore } from 'redux'
import { ReducerdData } from './Reducer';



 const Store = createStore(ReducerdData)
 export default Store